// src/hooks/useProviderInfo
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getProviderInfo } from '../../../store/new-visit/NewVisitThunk'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const useProviderInfo = (providerId, bookingId) => {
  const dispatch = useDispatch()
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const provider = useSelector((state) => state.newVisitReducer.visits[bookingId]?.provider)

  useEffect(() => {
    if (providerId) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getProviderInfo(providerId, bookingId))
    }
  }, [providerId, bookingId, dispatch])

  return provider
}
